import React, { useEffect, useMemo, useState } from "react";
import { IonPage, IonContent, useIonRouter } from "@ionic/react";
import "./HomePage.css";
import Header from "../../Header";
import { motion } from "framer-motion";
import GoalsSection from "../Guest/GuestGoals";
import TherapyActivitiesSection from "../../home/TherapyActivitiesSection";
import { containerVariants, itemVariants } from "../../../utils/helpers";
import {  generateMockDashboardData, getDailyData } from "../../../utils/guestHome";
import InsightsGraphVisx from "../../home/InsightsGraphVisx";
import { RequestPopup } from "./Components/RequestPopup";

const HomePage: React.FC = () => {
  const [activityAdherence, setActivityAdherence] = useState<any>(null);
  const [filteredTherapies, setFilteredTherapies] = useState<any[]>([]);
  const [InsightsData, setInsightsData] = useState<any>(null);
  const Router = useIonRouter();
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const [wholeActivityAdherence, setWholeActivityAdherence] = useState<any>(null);

  useEffect(() => {
    const activityAdherence: any = generateMockDashboardData();
    console.log("activityAdherence", activityAdherence);
    setInsightsData(activityAdherence?.insights);
    setWholeActivityAdherence(activityAdherence);
  }, []);

  useEffect(() => {
    // getDailyData is a function, call it to get the data
    setActivityAdherence(getDailyData());
  }, []);

  useEffect(() => {
    if (activityAdherence) {
      const paired = activityAdherence.therapies.filter(
        (therapy: any) => therapy.hasPairedDevice
      );
      setFilteredTherapies(paired);
    }
  }, [activityAdherence]);

  const homeLayoutConfig = useMemo(
    () => [
      {
        key: "InsightsSection",
        showIf: () => true,
      },
      {
        key: "TherapyActivitiesSection",
        showIf: () => filteredTherapies?.length > 0,
      },
      {
        key: "GoalsSection",
        showIf: () => true,
      },
    ],
    [filteredTherapies]
  );

  const renderInsightsSection = () => {
    if (!wholeActivityAdherence?.insights) return null;

    return (
      <InsightsGraphVisx
        profileId={8992}
        insightsData={InsightsData}
        dateRange={{
          startDate: wholeActivityAdherence.insights.startDate,
          endDate: wholeActivityAdherence.insights.endDate,
        }}
        isCurrentUser={true}
        isMockData={true}
        onClick={() => {
          setIsLoginPopupOpen(true);
        }}
      />
    );
  };

  const renderTherapyActivitiesSection = () => (
    <TherapyActivitiesSection
      title={"Today's Therapies"}
      formattedDate={new Date().toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
      })}
      activityAdherence={activityAdherence}
      filteredTherapies={filteredTherapies}
      onClick={(therapy) => console.log("Therapy clicked:", therapy)}
    />
  );

  const renderGoalsSection = () => <GoalsSection />;

  const componentMap: Record<string, () => React.ReactElement | null> = {
    InsightsSection: renderInsightsSection,
    TherapyActivitiesSection: renderTherapyActivitiesSection,
    GoalsSection: renderGoalsSection,
  };

  return (
    <IonPage>
      <IonContent className="main-content">
        <Header
          showGreeting={true}
          showUserName={true}
          userName="Guest Visitor"
          showAvatar={true}
        />
        <div
          className="home-container"
          style={{ minHeight: "100%", paddingBottom: "60px" }}
        >
          {isLoginPopupOpen && (
            <RequestPopup
              title="Guest View"
              buttonText="Proceed"
              onProceed={() => Router.push("/login")}
              onClose={() => setIsLoginPopupOpen(false)}
            />
          )}
          <motion.div
            className="cols-1 lg:grid-cols-2 lg:gap-4 lg:p-4 w-full"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            style={{ paddingBottom: "20px" }}
            transition={{
              type: "spring",
              stiffness: 80,
              damping: 18,
              duration: 0.8,
            }}
          >
            {homeLayoutConfig.map(
              (item) =>
                item.showIf() && (
                  <motion.div key={item.key} variants={itemVariants}>
                    {componentMap[item.key]()}
                  </motion.div>
                )
            )}
          </motion.div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
